import { styled } from "@ui/factory"

export const Image = styled("img")
